export default "__VITE_PUBLIC_ASSET__bcb27055__"